import { css } from '@emotion/react';

export const daySwitcherStyles = {
    root: css({
        width: '100%',
        marginTop: 14,
        marginBottom: 0,
    }),
    track: css({
        position: 'relative',
        width: '100%',
        height: 46,
        borderRadius: 999,
        backgroundColor: '#DAE7FA4D',
        overflow: 'hidden',
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        alignItems: 'center',
        padding: 4,
        boxSizing: 'border-box',
        border: '1px solid #DAE7FA',
    }),
    highlight: css({
        position: 'absolute',
        top: 4,
        left: 4,
        height: 38,
        width: 38,
        borderRadius: '50%',
        backgroundColor: '#0B63E6',
        transition: 'transform 260ms cubic-bezier(0.22, 1, 0.36, 1)',
        willChange: 'transform',
        zIndex: 0,
    }),
    dayButton: css({
        appearance: 'none',
        border: 'none',
        background: 'transparent',
        WebkitTapHighlightColor: 'transparent',
        padding: 0,
        margin: 0,
        height: 38,
        borderRadius: 999,
        fontFamily: 'Montserrat',
        fontSize: 14,
        fontWeight: 600,
        color: '#2B2B2B',
        cursor: 'pointer',
        position: 'relative',
        zIndex: 1,
        userSelect: 'none',
        outline: 'none',
        boxShadow: 'none',
        ['&:active']: {
            backgroundColor: 'transparent',
        },
        ['&[aria-selected="true"]']: {
            color: '#FFFFFF',
        },
        ['&:disabled']: {
            opacity: 0.45,
            cursor: 'not-allowed',
        },
    }),
};

